import { render, staticRenderFns } from "./control4Content.vue?vue&type=template&id=fa0b447c&scoped=true&"
import script from "./control4Content.vue?vue&type=script&lang=js&"
export * from "./control4Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0b447c",
  null
  
)

export default component.exports